import { keys } from 'lodash';
import { StoreState } from '../../app/app.reducers';

export const getReduxFormRegisteredFields = (formName: string) => (state: StoreState) =>
  keys(state?.form[formName]?.registeredFields || {});
